import React from 'react';
import PropTypes from 'prop-types';
import MembersGrid from '../MembersGrid';
import { DirectoryContainer } from './styled';

const TeamDirectory = ({ teamMembers, onMemberSelect, isLoading, error }) => {
  return (
    <DirectoryContainer>
      <MembersGrid
        teamMembers={teamMembers}
        onMemberSelect={onMemberSelect}
        isLoading={isLoading}
        error={error}
      />
    </DirectoryContainer>
  );
};

TeamDirectory.propTypes = {
  teamMembers: PropTypes.array.isRequired,
  onMemberSelect: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.bool
};

export default TeamDirectory;
